const CSV_INGEST_URL = process.env.API_URL + '/csv/variables/';
const CSV_GLUCOSE = process.env.API_URL + '/csv/variables/glucose/';
const OPTIONS = { headers: { 'Content-Type': 'multipart/form-data' } };

const uploadCsv = (context, file) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CSV_INGEST_URL, formData(file), OPTIONS)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const uploadGlucose = (context, username, file) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CSV_GLUCOSE + username, formData(file), OPTIONS)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const uploadCsvForUser = (context, username, file) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CSV_INGEST_URL + username, formData(file), OPTIONS)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const formData = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

export default {
  uploadCsv,
  uploadCsvForUser,
  uploadGlucose
};



// WEBPACK FOOTER //
// ./src/api/csvIngest/index.js